import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import {
  changeCardTrue,
  changeCardFalse,
} from "../../Redux/store/selectedCard";
import "react-datepicker/dist/react-datepicker.css";
import "swiper/css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { currentAppUrl } from "../../Constants/config";
import CurrencyDropdown from "../../Components/CustomDropdown/customCurrencyDropdown.js";
import { setCardCurrencyName } from "../../Redux/store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCardCurrencyName,
} from "../../Utils/cardCurrency";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

const CustomCardSlider = ({
  componentName,
  cardData,
  defaultCard,
  ondefaultCard,
}) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const [activeCard, setActiveCard] = useState(null); // Start with null initially
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [currencyData, setCurrencyData] = useState([]);
  const cardCurrencyNameFromStore = useSelector(selectCardCurrencyName);
  const cardCurrencyName = cardCurrencyNameFromStore;
  const [selectedCurrency, setSelectedCurrency] = useState(cardCurrencyName);
  const [preselectedcardCurrency, setpreselectedcardCurrency] = useState({
    value: cardCurrencyName.value,
    label: cardCurrencyName.label,
  });

  useEffect(() => {
    const currency = cardCurrencyNameFromStore;
    setSelectedCurrency(currency);
    setpreselectedcardCurrency({
      value: currency.value,
      label: currency.label,
    });
  }, [cardCurrencyNameFromStore]);
  useEffect(() => {
    setActiveCard(defaultCard); // Set the default card on initial render
  }, [defaultCard]);

  const handleCardClick = (card) => {
    // Toggle detailed section visibility for the clicked card
    if (
      (card.id == "1" || card.id == "2" || card.id == "3") &&
      componentName != "cashaccount-investment-details"
    ) {
      setActiveCard(card);
      ondefaultCard(card);
    }
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      localStorage.removeItem("jwtToken");
      navigate("/login");
      showToast("Session expired. Please log in again.", "error");
    }

    
    if (card.id == "4" && componentName != "cashaccount-investment-details") {
      // DONE
      window.location.href = `/my-account/property`;
    }
    if (card.id == "10" && componentName != "cashaccount-investment-details") {
      window.location.href = `/my-account/commodities`;
    }
    if (card.id == "5" && componentName != "cashaccount-investment-details") {
      window.location.href = `${currentAppUrl}/my-account/my-investment?bTok=${token}`;
    }
    if (card.id == "6" && componentName != "cashaccount-investment-details") {
      // DONE
      window.location.href = `my-account/fum`;
    }
    if (card.id == "7" && componentName != "cashaccount-investment-details") { 
      window.location.href = `my-account/custodian`;
    }
    // if (card.id == "7" && componentName != "cashaccount-investment-details") { 
    //   window.location.href = `my-account/private Wealth`;
    // }
    if (card.id == "10" && componentName != "cashaccount-investment-details") { 
      window.location.href = `${currentAppUrl}/my-account/securities?bTok=${token}`;
    }



    if (card.id == "9" && componentName != "cashaccount-investment-details") { 
      // DONE
      window.location.href = `/my-account/crypto`;
    }

    if (card.id == "5" && componentName != "cashaccount-investment-details") { 
      // DONE
      window.location.href = `/my-account/my-investment`;
    }

    if (card.id == "8" && componentName != "cashaccount-investment-details") { 
      // DONE
      window.location.href = `/my-account/securities`;
    }

  };
  useEffect(() => {
    if (activeCard == null) {
      dispatch(changeCardFalse({}));
    } else {
      dispatch(changeCardTrue(activeCard.id));
    }
  }, [activeCard]);
  useEffect(() => {
    setActiveCard(defaultCard);
  }, [defaultCard]);

  const swiperRef = useRef(null); // Reference to Swiper instance

  const handleNextClick = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext(); // Go to next slide
    }
  };
  const handleSelectCardCurrency = (selectedOption) => {
    setSelectedCurrency(selectedOption.label);
    dispatch(setCardCurrencyName(selectedOption));
    setpreselectedcardCurrency(selectedOption);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            symbol: profile.symbol,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const lineGraphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hides the legend
      },
      tooltip: {
        enabled: false, // Disables tooltips on hover
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Removes x-axis grid lines
          drawBorder: false, // Disables the axis border
          drawTicks: false, // Disables axis ticks
        },
        ticks: {
          display: false, // Hides x-axis labels
        },
        border: { display: false },
      },
      y: {
        grid: {
          display: false, // Removes y-axis grid lines
          drawBorder: false, // Disables the axis border
          drawTicks: false, // Disables axis ticks
        },
        ticks: {
          display: false, // Hides y-axis labels
        },
        border: { display: false },
      },
    },
    elements: {
      point: {
        radius: 0, // Removes data points
      },
    },
  };
  useEffect(() => {
    getAllCurrency();
  }, []);
  return (
    <div className="relative md:mr-2">
      {/* Custom Navigation Arrows */}
      <div
        onClick={handleNextClick}
        className={`absolute  right-2 transform -translate-y-1/2 translate-x-1/2 cursor-pointer z-10 md:block hidden ${
          componentName == "dashboard" ||
          componentName == "cashaccount-investment-details"
            ? "top-24"
            : "top-16"
        }`}
      >
        <img src="/right-card.svg" alt="Next" className="w-12 h-12" />
      </div>

      <Swiper
        ref={swiperRef}
        modules={[Navigation]}
        spaceBetween={16}
        navigation={{
          nextEl: ".swiper-button-next",
        }}
        className="custom-swiper overflow-visible"
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 5,
          },
        }}
      >
        {cardData.map((card, index) => (
          <SwiperSlide
            key={index}
            onClick={() => !card.isLocked && handleCardClick(card)}
            className={`relative group h-40 min-h-40 max-h-40  mb-5 flex-none rounded-lg p-4 border-2 border-transparent  ${
              activeCard || defaultCard
                ? activeCard === card || defaultCard.id === card.id
                  ? "border-white border-2 " + card.color
                  : card.lessColor
                : card.color
            }
            ${
              card.isLocked || componentName == "cashaccount-investment-details"
                ? ""
                : " cursor-pointer hover:border-white hover:border-2"
            }
            `}
          >
            {card.isLocked && (
              <div className="absolute inset-0 z-40 flex flex-col items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm rounded-lg px-4 text-center">
                <img
                  src="/lock.svg"
                  alt="Locked"
                  className="w-8 h-8 opacity-90 mb-2 z-90"
                  title="Account not found"
                />
                <span className="text-white font-semibold text-sm  select-none max-w-full">
                  {card.label}
                </span>
              </div>
            )}
            {activeCard === card && (
              <div className="absolute bottom-[-40px] left-1/2 transform  -translate-x-1/2 z-[9999]">
                <div
                  className={`w-0 h-10 border-l-[10px] border-r-[10px] border-t-[16px] border-l-transparent border-r-transparent  ${card.tail}`}
                  style={{
                    borderRadius: "0 0 15px 15px", // Rounds the bottom of the curve
                  }}
                ></div>
              </div>
            )}
            {/* Card Content */}
            <div className="text-left mb-0">
              <div
                onClick={(e) => e.stopPropagation()}
                className="flex items-center justify-start"
              >
                {/* <select
                  value={selectedCurrency}
                  onChange={handleSelectCardCurrency}
                  className="bg-transparent text-md font-semibold text-white border border-white rounded-md px-1 py-0.5 focus:outline-none cursor-pointer w-[70px] sm:w-[80px]"
                >
                  {currencyData.map((currency) => (
                    <option
                      key={currency.value}
                      value={currency.label}
                      className="text-black"
                    >
                      {currency.label}
                    </option>
                  ))}
                </select> */}
                {currencyData.length > 0 && (
                  <div className="w-32">
                    {" "}
                    <CurrencyDropdown
                      label=""
                      options={currencyData}
                      search={true}
                      preselectedValue={preselectedcardCurrency}
                      onSelect={handleSelectCardCurrency}
                      colorLabel=""
                    />
                  </div>
                )}
              </div>
              {/* Balance */}
              <h2 className="text-md font-semibold text-white mt-1">
                {cardCurrencyName.symbol}
                {card.amount
                  ? Number(card.amount)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "0.00"}
              </h2>
              <p
                className={`font-semibold text-white ${
                  componentName == "dashboard" ||
                  componentName == "cashaccount-investment-details"
                    ? "text-sm"
                    : "text-sm"
                }`}
              >
                {card.label}
              </p>
            </div>

            {/* Line Graph */}
            {(componentName == "dashboard" ||
              componentName == "cashaccount-investment-details") && (
              <div className="h-20 w-full">
                <Line
                  className="pb-6"
                  data={card.graphdata}
                  options={lineGraphOptions}
                />
              </div>
            )}
            {/* Hover Arrow */}
            <div
              className={`absolute top-0 right-0  z-20 transition-all duration-200 ${
                activeCard === card || defaultCard.id === card.id
                  ? "block"
                  : "hidden"
              }${
                componentName != "cashaccount-investment-details" &&
                !card.isLocked
                  ? " group-hover:block"
                  : ""
              }
              `}
            >
              <img
                src="/arrow-right-c.svg"
                alt="Arrow"
                className="w-6 h-6 m-2"
                onError={(e) => {
                  e.target.style.display = "none";
                  console.error("Image not found:", e.target.src);
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CustomCardSlider;
